(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'BucketAttachment',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var bucket_id,
			current_amount,
			new_amount,
			items_added;

		if (!Adzuki.Form.hasError(response)) {
			if (response.status === 'success') {
				bucket_id   = response.data.bucket_id;
				items_added = response.data.num_attachments;

				Adzuki.StatusMessage('success', 'Your attachment has been saved to this bucket', 'Success', {
					onClose: function savedClosed() {
						Adzuki.Ajax.get('/Buckets/items/' + bucket_id)
							.then(function _showBucketItems(content) {
								$('.bucket-contents').html(content);

								current_amount = $('#bucket-item-count-' + bucket_id).html();
								new_amount     = parseInt(current_amount) + items_added;

								$('#bucket-item-count-' + bucket_id).html(new_amount);

								Adzuki.Ajax.get('/Buckets/addEditAttachment/' + bucket_id)
								.then(function _addEditAttachment(response) {
									$('#bucket-files').html(response);
									Adzuki.Form.initAjaxForm('BucketAttachment');
									setTimeout(
										function initDragAndDrop() {
											Adzuki.DragDropUpload.start($('.file-upload-options'));
										},
									500);
								});

								Adzuki.Ajax.get('/Buckets/addEditLink/' + bucket_id)
								.then(function _addEditLink(response) {
									$('#bucket-links').html(response);
									Adzuki.Form.initAjaxForm('BucketLink');
								});
						});
					},
				});
			}
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving attachments');

		return false;
	};

}(jQuery, window.Adzuki || {}));
